import { i18n } from 'localization'
import { parseDate, parsePerson } from './utils'
import { LinkedElementType } from 'utils/enums'
import MedicalOpinion from './MedicalOpinion'

const MANAGEMENT_OPINION = 'Parecer De Gestão'

export default class TrustNotification {
	static fromJSON(json) {
		return new TrustNotification(json.id, json.isRead)
			.withTitle(json.title)
			.withBody(json.body)
			.withSourceEstablishment(json.sourceEstablishment)
			.withDate(json.createdAt)
			.withInjured(json.injured)
			.withReadStatus(json.isRead)
			.withProcessId(json.processId)
			.withCreationUser(json.creationUser)
			.withInsuranceEntityId(json.insuranceEntityId)
			.withCausaltyBranch(json.causaltyBranch)
			.withLink(json)
			.withThread(json.thread)
			.withOpinion(json.opinion)
			.withNotificationType(json.notificationType)
			.withNotificationTypeId(json)
			.withDescription(json.description)
			.withUserCreate(json.userCreate)
			.withNotificationDate(json.notificationDate)
			.withForwarded(json.isForwarded)
			.withNotificationTypeId(json.idNotificationType)
	}

	constructor(id, read) {
		this.id = id
		this.key = `trust_notification_${id || ''}_${read || ''}`
		this.textId = `trust_notification_${id || ''}`
	}

	withTitle(title) {
		this.title = i18n.translate(title)
		return this
	}

	withBody(body) {
		this.body = body?.replace(/<br\/>/gi, '\r\n')
		this.text = this.body
		return this
	}

	withSourceEstablishment(sourceEstablishment) {
		this.sourceEstablishment = sourceEstablishment
		return this
	}

	withDate(dateStr) {
		if (dateStr) {
			this.date = parseDate(dateStr)
		} else {
			this.date = {}
		}
		return this
	}

	withInjured(json) {
		this.injured = json ? parsePerson(json) : null
		return this
	}

	withReadStatus(isRead) {
		this.isRead = isRead
		return this
	}

	withProcessId(processId) {
		this.processId = processId?.toString()
		return this
	}

	withCreationUser(json) {
		this.creationUser = json ? parsePerson(json) : null
		return this
	}

	withInsuranceEntityId(insuranceEntityId) {
		this.insuranceEntityId = insuranceEntityId
		return this
	}

	withCausaltyBranch(causaltyBranch) {
		this.causaltyBranch = causaltyBranch
		return this
	}

	withLink(json) {
		if (json.opinion?.opinionType === MANAGEMENT_OPINION) {
			this.action = null
			return this
		}

		if (json.processId) {
			const initialUrl = `/clinical-processes/${json.processId}`

			if (json.thread?.id) {
				const searchParams = `?comment=${json.thread.id}&notificationId=${json.id}`

				if (json.thread?.linkedElementId) {
					if (
						json.thread?.linkedElementType ===
						LinkedElementType.Appointment
					) {
						this.link = {
							to: `${initialUrl}/appointments/${searchParams}#C_${json.thread.linkedElementId}`,
							name: i18n`See appointment`,
						}
					} else {
						this.link = {
							to: `${initialUrl}/requisitions/${searchParams}#R_${json.thread.linkedElementId}`,
							name: i18n`See requisition`,
						}
					}
				} else {
					this.link = {
						to: `${initialUrl}/comments/${searchParams}`,
						name: i18n`See comment`,
					}
				}
			} else {
				this.link = {
					to: `${initialUrl}/appointments?notificationId=${json.id}`,
					name: i18n`See clinical process`,
				}
			}
		}

		return this
	}

	withThread(json) {
		this.thread = json ? json : null
		return this
	}

	withOpinion(json) {
		this.opinion = json ? MedicalOpinion.fromJSON(json) : null
		return this
	}

	withNotificationType(json) {
		this.notificationType = json ? json.type : null
		return this
	}

	withNotificationTypeId(json) {
		this.idNotificationType = json ? json.idNotificationType : null
		return this
	}
	withDescription(description) {
		this.description = description
		return this
	}

	withUserCreate(userCreate) {
		this.userCreate = userCreate ? parsePerson(userCreate) : null
		return this
	}

	withNotificationDate(dateStr) {
		if (dateStr) {
			this.notificationDate = parseDate(dateStr)
		} else {
			this.notificationDate = {}
		}
		return this
	}

	withForwarded(isForwarded) {
		this.isForwarded = !!isForwarded

		return this
	}

	withNotificationTypeId(idNotificationType) {
		this.idNotificationType = idNotificationType
		return this
	}
}
